// extracted by mini-css-extract-plugin
export var orderSummary = "_m2-0";
export var showMoreLessButton = "_m2-1";